module.exports = __webpack_public_path__ + "img/pic_090036.bb98da18.jpg";